module.exports = __webpack_public_path__ + "img/ep-F-dosis.ba536221.jpg";